import { render, staticRenderFns } from "./Groningen.vue?vue&type=template&id=3fc29a99&"
var script = {}
import style0 from "./Groningen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Groningen.vue"
export default component.exports